// src/configs/aws-config.js
import { COGNITO_CONFIG } from '@/data/services/api/apiConfig'

/**
 * Get the redirect URI for Cognito authentication
 * Uses current origin dynamically (no hardcoding) to support:
 * - localhost (development)
 * - Network IPs (192.168.x.x)
 * - Production domains
 *
 * Can be overridden via VITE_COGNITO_REDIRECT_URI environment variable
 * @returns {string} Redirect URI
 */
const getRedirectUri = () => {
  // Allow explicit override via environment variable
  if (import.meta.env.VITE_COGNITO_REDIRECT_URI) {
    return import.meta.env.VITE_COGNITO_REDIRECT_URI
  }

  // Use current origin dynamically (works in browser environment)
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin
  }

  // Fallback for SSR or non-browser environments (shouldn't happen in this app)
  return 'http://localhost:5173'
}

const awsConfig = {
  Auth: {
    Cognito: {
      region: COGNITO_CONFIG.region,
      userPoolId: COGNITO_CONFIG.userPoolId,
      userPoolClientId: COGNITO_CONFIG.userPoolWebClientId,
      loginWith: {
        username: true,
        email: false,
      },
      // Configure redirect URIs dynamically based on current origin
      // This allows the app to work from localhost, network IPs, or production domains
      // Note: These URLs must also be whitelisted in Cognito User Pool App Client settings
      signInRedirectUri: getRedirectUri(),
      signOutRedirectUri: getRedirectUri(),
    },
  },
}

export default awsConfig
